import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from 'antd'

export interface BadgeProps extends BaseBadgeProps {}

export const Badge = (props: BadgeProps): JSX.Element => (
  <>
    <BaseBadge {...props} />
  </>
)
